// src/plugins/vuetify.js

import Vue from 'vue'
import Vuetify from 'vuetify'
import 'vuetify/dist/vuetify.min.css'

const opts = {
  theme: {
    dark: false,
    themes: {
      light: {
        primary: '#0096A6', //'#1976D2', // teal
        secondary: '#97C131', //'#424242', // green
        accent: '#CCEAED', //'#82B1FF', light-primary
        error: '#DF452E',
        info: '#00A50B', //'#2196F3', pure green
        success: '#D6E8A8', //'#4CAF50', light-green
        warning: '#F1563F', // red-orange
        
        general_grey: '#5F6062', // SAME AS grow
        general_lightgrey: '#E6E7E8',
        xtralight_primary: '#eef7f8', // extra light primary
        
        value: '#97C131', // secondary
        improve: '#F1563F', // warning 
        protect: '#323038', // black
        grow: '#5F6062', // dark-grey
        lend: '#194253', // dark-blue // navy
        exit: '#0096A6', // primary
      }
    },
    options: { 
      variations: true,
      customProperties: true
    },
    typography: {
      fontFamily: [
        'Sansation',
        'Avenir',
        'Roboto',
        '"Helvetica Neue"',
        'Arial',
        'sans-serif',
      ].join(','),
    }
  }
};

Vue.use(Vuetify)

export default new Vuetify( opts );


// WEBPACK FOOTER //
// ./src/plugins/vuetify.js